import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/views/index'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/about'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/staffs',
      name: 'Staffs',
      component: () => import('@/views/staffs'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import('@/views/contact'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/news',
      name: 'NewsList',
      component: () => import('@/views/news/index'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/news/:id',
      name: 'NewsInfo',
      component: () => import('@/views/news/info')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login')
    },
    {
      path: '/products',
      name: 'products',
      component: () => import('@/views/product/list')
    },
    {
      path: '/products/:id',
      name: 'products',
      component: () => import('@/views/product/info')
    },
    {
      path: '/carts',
      name: 'carts',
      component: () => import('@/views/cart')
    }
  ]
})
